import { hollowDotIndices, numberInWords, TRACKING_CENSUSES } from "@/content/trackingCensus";
import { SectionHeader } from "./primitives";

export function TrackingCensus({ total, hollow, cols = 27, mobileCols = 18 }: { total: number; hollow: number; cols?: number; mobileCols?: number }) {
  const indices = hollowDotIndices(total, hollow);
  return <div className="tracking-census" data-total={total} data-hollow={hollow} data-cols={cols} data-cols-mobile={mobileCols} role="img"
    aria-label={`${numberInWords(total)} websites scanned; ${numberInWords(hollow)} had no conversion tracking, shown as hollow bronze rings.`}>
    {Array.from({ length: total }, (_, index) => <i key={index} aria-hidden="true" className={indices.has(index) ? "census-dot census-hollow" : "census-dot"} />)}
  </div>;
}

export function IndustryTrackingCensus({ industry }: { industry: string }) {
  const data = TRACKING_CENSUSES[industry];
  if (!data) return null;
  return <section className="bhg-section census-section">
    <div className="wrap">
      <SectionHeader num={`${data.trade}, measured`} title={<>{data.total} {data.trade} websites, <span className="display-italic">loaded in a real browser.</span></>}>
        One dot for every {data.trade} company website in our 2026 scan. The hollow ones had no conversion tracking at all.
      </SectionHeader>
      <div className="census-layout mt-12">
        <div>
          <div className="census-percentage tnum text-champagne" data-countup="">{data.percentage}</div>
          <p className="mt-4 text-bleu-dim">{data.hollow} of {data.total} {data.trade} sites could not record a lead.</p>
          {data.adsPercentage && <div className="mt-8">
            <div className="census-ad-percentage tnum text-bleu" data-countup="">{data.adsPercentage}</div>
            <p className="mt-3 text-bleu-dim">of the {data.advertisers} confirmed to be running ads had none.</p>
          </div>}
        </div>
        <TrackingCensus total={data.total} hollow={data.hollow} />
      </div>
      <p className="mono census-caption mt-8 text-bleu-faint"><a href="/research/conversion-tracking-report" className="underline underline-offset-4">BHG Conversion Tracking Report, 2026 edition.</a> Dot order is shuffled, not ranked.</p>
    </div>
  </section>;
}